import React from 'react';

//Components
import UserAvatar from '../../../common/UserAvatar/UserAvatar';

//Types
import {HostInfoShape} from '@stencil/hotels-cg-reducer/src/details/types';

//Styles
import * as S from './HostDetailsModal.styles';

//Utils
import {isValidArray} from '@stencil/hotels-utils/src/common-utils';

interface HostDetailsModalProps {
  hostInfo?: HostInfoShape;
  renderHostListInfo: ({removeText: string}) => void;
  showFullHostImage?: boolean;
}

const HostDetailsModal: React.FC<HostDetailsModalProps> = ({
  hostInfo,
  renderHostListInfo,
  showFullHostImage,
}) => {
  const hostAbout = hostInfo?.about?.replace(/\n/g, '<br>');

  return (
    <S.Container showFullHostImage={showFullHostImage}>
      {showFullHostImage ? (
        <S.FullImg src={hostInfo?.hostImage} alt={'hostImage'} />
      ) : (
        <React.Fragment>
          <S.ModalHdr>
            <div>
              <S.Title>Hi, I'm {hostInfo?.name}</S.Title>
              <S.SubTitle>{hostInfo?.timeSinceHostingOnMmt}</S.SubTitle>
            </div>
            <S.HostImg>
              <UserAvatar
                userImg={hostInfo?.hostImage}
                firstName={hostInfo?.name}
                size={'8.7rem'}
              />
            </S.HostImg>
          </S.ModalHdr>
          <S.HostList>
            {renderHostListInfo({removeText: hostInfo?.timeSinceHostingOnMmt})}
          </S.HostList>
          {hostAbout && <S.HostBio dangerouslySetInnerHTML={{__html: hostAbout}} />}
          {!!hostInfo?.caretakerAvailability && (
            <S.Responsibilities>
              <div dangerouslySetInnerHTML={{__html: hostInfo?.caretakerAvailability}} />
            </S.Responsibilities>
          )}
          {isValidArray(hostInfo?.caretakerResponsibilities) && (
            <S.Responsibilities>
              <span className="latoBold">Caretaker Responsibilities:</span>{' '}
              {hostInfo?.caretakerResponsibilities?.join(', ')}
            </S.Responsibilities>
          )}
        </React.Fragment>
      )}
    </S.Container>
  );
};

export default HostDetailsModal;
